export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        <div className="font-mono-label text-[10px] text-[#0052CC] mb-2">{subtitle}</div>
        <h1 className="font-display font-bold text-3xl tracking-tight text-slate-900">{title}</h1>
      </div>
      {action}
    </div>
  );
}
